import React from 'react';
import PropTypes from 'prop-types';
import './BulletList.scss';

const BulletList = ({children, className, ...props}) => (
  <div className={`bullet-list ${className}`} {...props}>
    {children}
  </div>
);

BulletList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BulletList;
